import { cabinetApi as api } from "../api";
export const addTagTypes = [
  "api",
  "AnalyticsEventColor",
  "EventCategory",
  "EventType",
  "ExecContactCategory",
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      appAnalyticsAnalysisInclusionsList: build.query<
        AppAnalyticsAnalysisInclusionsListApiResponse,
        AppAnalyticsAnalysisInclusionsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/analysis-inclusions/`,
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        providesTags: ["api"],
      }),
      appAnalyticsAnalysisInclusionsRetrieve: build.query<
        AppAnalyticsAnalysisInclusionsRetrieveApiResponse,
        AppAnalyticsAnalysisInclusionsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/analysis-inclusions/${queryArg}/`,
        }),
        providesTags: ["api"],
      }),
      appAnalyticsAnalyticsColorsList: build.query<
        AppAnalyticsAnalyticsColorsListApiResponse,
        AppAnalyticsAnalyticsColorsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/analytics-colors/`,
          params: {
            calendar: queryArg.calendar,
            category: queryArg.category,
            color: queryArg.color,
            event_category: queryArg.eventCategory,
            event_type: queryArg.eventType,
            order_by: queryArg.orderBy,
            topology: queryArg.topology,
          },
        }),
        providesTags: ["AnalyticsEventColor"],
      }),
      appAnalyticsAnalyticsColorsRetrieve: build.query<
        AppAnalyticsAnalyticsColorsRetrieveApiResponse,
        AppAnalyticsAnalyticsColorsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/analytics-colors/${queryArg}/`,
        }),
        providesTags: ["AnalyticsEventColor"],
      }),
      appAnalyticsAnalyticsColorsUpdate: build.mutation<
        AppAnalyticsAnalyticsColorsUpdateApiResponse,
        AppAnalyticsAnalyticsColorsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/analytics-colors/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.analyticsEventColorRequest,
        }),
        invalidatesTags: ["AnalyticsEventColor"],
      }),
      appAnalyticsAnalyticsColorsPartialUpdate: build.mutation<
        AppAnalyticsAnalyticsColorsPartialUpdateApiResponse,
        AppAnalyticsAnalyticsColorsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/analytics-colors/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedAnalyticsEventColor,
        }),
        invalidatesTags: ["AnalyticsEventColor"],
      }),
      appAnalyticsConsolidatedLocationsList: build.query<
        AppAnalyticsConsolidatedLocationsListApiResponse,
        AppAnalyticsConsolidatedLocationsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/consolidated-locations/`,
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        providesTags: ["api"],
      }),
      appAnalyticsConsolidatedLocationsRetrieve: build.query<
        AppAnalyticsConsolidatedLocationsRetrieveApiResponse,
        AppAnalyticsConsolidatedLocationsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/consolidated-locations/${queryArg}/`,
        }),
        providesTags: ["api"],
      }),
      appAnalyticsContactEventsList: build.query<
        AppAnalyticsContactEventsListApiResponse,
        AppAnalyticsContactEventsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/contact-events/`,
          params: {
            attendees: queryArg.attendees,
            attendees_in: queryArg.attendeesIn,
            attendees_isnull: queryArg.attendeesIsnull,
            distinct: queryArg.distinct,
            distinct_in: queryArg.distinctIn,
            distinct_isnull: queryArg.distinctIsnull,
            end_date: queryArg.endDate,
            end_date_gt: queryArg.endDateGt,
            end_date_gte: queryArg.endDateGte,
            end_date_in: queryArg.endDateIn,
            end_date_isnull: queryArg.endDateIsnull,
            end_date_lt: queryArg.endDateLt,
            end_date_lte: queryArg.endDateLte,
            id: queryArg.id,
            id_gt: queryArg.idGt,
            id_gte: queryArg.idGte,
            id_in: queryArg.idIn,
            id_isnull: queryArg.idIsnull,
            id_lt: queryArg.idLt,
            id_lte: queryArg.idLte,
            leaders: queryArg.leaders,
            leaders_in: queryArg.leadersIn,
            leaders_isnull: queryArg.leadersIsnull,
            limit: queryArg.limit,
            offset: queryArg.offset,
            order_by: queryArg.orderBy,
            start_date: queryArg.startDate,
            start_date_gt: queryArg.startDateGt,
            start_date_gte: queryArg.startDateGte,
            start_date_in: queryArg.startDateIn,
            start_date_isnull: queryArg.startDateIsnull,
            start_date_lt: queryArg.startDateLt,
            start_date_lte: queryArg.startDateLte,
            title: queryArg.title,
            title_contains: queryArg.titleContains,
            title_endswith: queryArg.titleEndswith,
            title_icontains: queryArg.titleIcontains,
            title_iexact: queryArg.titleIexact,
            title_in: queryArg.titleIn,
            title_ine: queryArg.titleIne,
            title_isempty: queryArg.titleIsempty,
            title_isnull: queryArg.titleIsnull,
            title_ne: queryArg.titleNe,
            title_not_contains: queryArg.titleNotContains,
            title_not_icontains: queryArg.titleNotIcontains,
            title_startswith: queryArg.titleStartswith,
          },
        }),
        providesTags: ["api"],
      }),
      appAnalyticsEventCategoriesList: build.query<
        AppAnalyticsEventCategoriesListApiResponse,
        AppAnalyticsEventCategoriesListApiArg
      >({
        query: () => ({ url: `/api/v1_15/app-analytics/event-categories/` }),
        providesTags: ["EventCategory"],
      }),
      appAnalyticsEventCategoriesCreate: build.mutation<
        AppAnalyticsEventCategoriesCreateApiResponse,
        AppAnalyticsEventCategoriesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/event-categories/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["EventCategory"],
      }),
      appAnalyticsEventCategoriesRetrieve: build.query<
        AppAnalyticsEventCategoriesRetrieveApiResponse,
        AppAnalyticsEventCategoriesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/event-categories/${queryArg}/`,
        }),
        providesTags: ["EventCategory"],
      }),
      appAnalyticsEventCategoriesUpdate: build.mutation<
        AppAnalyticsEventCategoriesUpdateApiResponse,
        AppAnalyticsEventCategoriesUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/event-categories/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.eventCategoryRequest,
        }),
        invalidatesTags: ["EventCategory"],
      }),
      appAnalyticsEventCategoriesPartialUpdate: build.mutation<
        AppAnalyticsEventCategoriesPartialUpdateApiResponse,
        AppAnalyticsEventCategoriesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/event-categories/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedEventCategory,
        }),
        invalidatesTags: ["EventCategory"],
      }),
      appAnalyticsEventCategoriesDestroy: build.mutation<
        AppAnalyticsEventCategoriesDestroyApiResponse,
        AppAnalyticsEventCategoriesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/event-categories/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["EventCategory"],
      }),
      appAnalyticsEventTypesList: build.query<
        AppAnalyticsEventTypesListApiResponse,
        AppAnalyticsEventTypesListApiArg
      >({
        query: () => ({ url: `/api/v1_15/app-analytics/event-types/` }),
        providesTags: ["EventType"],
      }),
      appAnalyticsEventTypesCreate: build.mutation<
        AppAnalyticsEventTypesCreateApiResponse,
        AppAnalyticsEventTypesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/event-types/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["EventType"],
      }),
      appAnalyticsEventTypesRetrieve: build.query<
        AppAnalyticsEventTypesRetrieveApiResponse,
        AppAnalyticsEventTypesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/event-types/${queryArg}/`,
        }),
        providesTags: ["EventType"],
      }),
      appAnalyticsEventTypesUpdate: build.mutation<
        AppAnalyticsEventTypesUpdateApiResponse,
        AppAnalyticsEventTypesUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/event-types/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.eventTypeRequest,
        }),
        invalidatesTags: ["EventType"],
      }),
      appAnalyticsEventTypesPartialUpdate: build.mutation<
        AppAnalyticsEventTypesPartialUpdateApiResponse,
        AppAnalyticsEventTypesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/event-types/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedEventType,
        }),
        invalidatesTags: ["EventType"],
      }),
      appAnalyticsEventTypesDestroy: build.mutation<
        AppAnalyticsEventTypesDestroyApiResponse,
        AppAnalyticsEventTypesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/event-types/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["EventType"],
      }),
      appAnalyticsEventsList: build.query<
        AppAnalyticsEventsListApiResponse,
        AppAnalyticsEventsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/events/`,
          params: {
            attendee_lookup: queryArg.attendeeLookup,
            attendees: queryArg.attendees,
            consolidated_location: queryArg.consolidatedLocation,
            date_scheduled: queryArg.dateScheduled,
            end_date: queryArg.endDate,
            event_category: queryArg.eventCategory,
            event_type: queryArg.eventType,
            inclusion: queryArg.inclusion,
            is_all_day: queryArg.isAllDay,
            is_busy: queryArg.isBusy,
            leader: queryArg.leader,
            limit: queryArg.limit,
            local_tz_offset: queryArg.localTzOffset,
            offset: queryArg.offset,
            order_by: queryArg.orderBy,
            recurrence_type: queryArg.recurrenceType,
            search: queryArg.search,
            start_date: queryArg.startDate,
            status: queryArg.status,
            title: queryArg.title,
            topology: queryArg.topology,
          },
        }),
        providesTags: ["api"],
      }),
      appAnalyticsEventsUpdate: build.mutation<
        AppAnalyticsEventsUpdateApiResponse,
        AppAnalyticsEventsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/events/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.leaderEventRequest,
        }),
        invalidatesTags: ["api"],
      }),
      appAnalyticsEventsPartialUpdate: build.mutation<
        AppAnalyticsEventsPartialUpdateApiResponse,
        AppAnalyticsEventsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/events/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedLeaderEvent,
        }),
        invalidatesTags: ["api"],
      }),
      appAnalyticsEventsGraphAnalyticsCreate: build.mutation<
        AppAnalyticsEventsGraphAnalyticsCreateApiResponse,
        AppAnalyticsEventsGraphAnalyticsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/events/graph-analytics/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["api"],
      }),
      appAnalyticsEventsRecurringSeriesList: build.query<
        AppAnalyticsEventsRecurringSeriesListApiResponse,
        AppAnalyticsEventsRecurringSeriesListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/events/recurring-series/`,
          params: {
            active: queryArg.active,
            leader: queryArg.leader,
            search: queryArg.search,
          },
        }),
        providesTags: ["api"],
      }),
      appAnalyticsEventsRecurringSeriesHideCreate: build.mutation<
        AppAnalyticsEventsRecurringSeriesHideCreateApiResponse,
        AppAnalyticsEventsRecurringSeriesHideCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/events/recurring-series/hide/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["api"],
      }),
      appAnalyticsEventsRecurringSeriesUpdate: build.mutation<
        AppAnalyticsEventsRecurringSeriesUpdateApiResponse,
        AppAnalyticsEventsRecurringSeriesUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/events/recurring-series/update/`,
          method: "PATCH",
          body: queryArg,
        }),
        invalidatesTags: ["api"],
      }),
      appAnalyticsEventsResyncRetrieve: build.query<
        AppAnalyticsEventsResyncRetrieveApiResponse,
        AppAnalyticsEventsResyncRetrieveApiArg
      >({
        query: () => ({ url: `/api/v1_15/app-analytics/events/resync/` }),
        providesTags: ["api"],
      }),
      appAnalyticsExecutiveContactCategoriesList: build.query<
        AppAnalyticsExecutiveContactCategoriesListApiResponse,
        AppAnalyticsExecutiveContactCategoriesListApiArg
      >({
        query: () => ({
          url: `/api/v1_15/app-analytics/executive-contact-categories/`,
        }),
        providesTags: ["ExecContactCategory"],
      }),
      appAnalyticsExecutiveContactCategoriesCreate: build.mutation<
        AppAnalyticsExecutiveContactCategoriesCreateApiResponse,
        AppAnalyticsExecutiveContactCategoriesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/executive-contact-categories/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["ExecContactCategory"],
      }),
      appAnalyticsExecutiveContactCategoriesRetrieve: build.query<
        AppAnalyticsExecutiveContactCategoriesRetrieveApiResponse,
        AppAnalyticsExecutiveContactCategoriesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/executive-contact-categories/${queryArg}/`,
        }),
        providesTags: ["ExecContactCategory"],
      }),
      appAnalyticsExecutiveContactCategoriesUpdate: build.mutation<
        AppAnalyticsExecutiveContactCategoriesUpdateApiResponse,
        AppAnalyticsExecutiveContactCategoriesUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/executive-contact-categories/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.execTagRequest,
        }),
        invalidatesTags: ["ExecContactCategory"],
      }),
      appAnalyticsExecutiveContactCategoriesPartialUpdate: build.mutation<
        AppAnalyticsExecutiveContactCategoriesPartialUpdateApiResponse,
        AppAnalyticsExecutiveContactCategoriesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/executive-contact-categories/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedExecTag,
        }),
        invalidatesTags: ["ExecContactCategory"],
      }),
      appAnalyticsExecutiveContactCategoriesDestroy: build.mutation<
        AppAnalyticsExecutiveContactCategoriesDestroyApiResponse,
        AppAnalyticsExecutiveContactCategoriesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/executive-contact-categories/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["ExecContactCategory"],
      }),
      appAnalyticsExecutiveContactTypesList: build.query<
        AppAnalyticsExecutiveContactTypesListApiResponse,
        AppAnalyticsExecutiveContactTypesListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/executive-contact-types/`,
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        providesTags: ["api"],
      }),
      appAnalyticsExecutiveContactTypesRetrieve: build.query<
        AppAnalyticsExecutiveContactTypesRetrieveApiResponse,
        AppAnalyticsExecutiveContactTypesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/executive-contact-types/${queryArg}/`,
        }),
        providesTags: ["api"],
      }),
      appAnalyticsExecutiveContactsRetrieve: build.query<
        AppAnalyticsExecutiveContactsRetrieveApiResponse,
        AppAnalyticsExecutiveContactsRetrieveApiArg
      >({
        query: () => ({ url: `/api/v1_15/app-analytics/executive-contacts/` }),
        providesTags: ["api"],
      }),
      appAnalyticsExecutiveContactsUpdate: build.mutation<
        AppAnalyticsExecutiveContactsUpdateApiResponse,
        AppAnalyticsExecutiveContactsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/executive-contacts/${queryArg}/`,
          method: "PUT",
        }),
        invalidatesTags: ["api"],
      }),
      appAnalyticsExecutiveContactsPartialUpdate: build.mutation<
        AppAnalyticsExecutiveContactsPartialUpdateApiResponse,
        AppAnalyticsExecutiveContactsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/executive-contacts/${queryArg}/`,
          method: "PATCH",
        }),
        invalidatesTags: ["api"],
      }),
      appAnalyticsExecutiveContactsAttendeeAnalyticsCreate: build.mutation<
        AppAnalyticsExecutiveContactsAttendeeAnalyticsCreateApiResponse,
        AppAnalyticsExecutiveContactsAttendeeAnalyticsCreateApiArg
      >({
        query: () => ({
          url: `/api/v1_15/app-analytics/executive-contacts/attendee-analytics/`,
          method: "POST",
        }),
        invalidatesTags: ["api"],
      }),
      appAnalyticsRecurrenceTypesList: build.query<
        AppAnalyticsRecurrenceTypesListApiResponse,
        AppAnalyticsRecurrenceTypesListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-analytics/recurrence-types/`,
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        providesTags: ["api"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as analyticsGenerated };
export type AppAnalyticsAnalysisInclusionsListApiResponse =
  /** status 200  */ PaginatedAnalysisInclusionList;
export type AppAnalyticsAnalysisInclusionsListApiArg = {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type AppAnalyticsAnalysisInclusionsRetrieveApiResponse =
  /** status 200  */ AnalysisInclusion;
export type AppAnalyticsAnalysisInclusionsRetrieveApiArg =
  /** A unique integer value identifying this analysis inclusion. */ number;
export type AppAnalyticsAnalyticsColorsListApiResponse =
  /** status 200  */ AnalyticsEventColor[];
export type AppAnalyticsAnalyticsColorsListApiArg = {
  calendar?: string;
  category?: string;
  color?: string;
  eventCategory?: number;
  eventType?: number;
  /** Ordering
    
    * `color` - Color
    * `-color` - Color (descending)
    * `category` - Category
    * `-category` - Category (descending)
    * `calendar` - Calendar
    * `-calendar` - Calendar (descending)
    * `event_category` - Event category
    * `-event_category` - Event category (descending)
    * `event_type` - Event type
    * `-event_type` - Event type (descending) */
  orderBy?: (
    | "-calendar"
    | "-category"
    | "-color"
    | "-event_category"
    | "-event_type"
    | "calendar"
    | "category"
    | "color"
    | "event_category"
    | "event_type"
  )[];
  /** * `and` - And
   * `or` - Or */
  topology?: "and" | "or";
};
export type AppAnalyticsAnalyticsColorsRetrieveApiResponse =
  /** status 200  */ AnalyticsEventColor;
export type AppAnalyticsAnalyticsColorsRetrieveApiArg =
  /** A unique integer value identifying this analytics event color. */ number;
export type AppAnalyticsAnalyticsColorsUpdateApiResponse =
  /** status 200  */ AnalyticsEventColor;
export type AppAnalyticsAnalyticsColorsUpdateApiArg = {
  /** A unique integer value identifying this analytics event color. */
  id: number;
  analyticsEventColorRequest: AnalyticsEventColorRequest;
};
export type AppAnalyticsAnalyticsColorsPartialUpdateApiResponse =
  /** status 200  */ AnalyticsEventColor;
export type AppAnalyticsAnalyticsColorsPartialUpdateApiArg = {
  /** A unique integer value identifying this analytics event color. */
  id: number;
  patchedAnalyticsEventColor: PatchedAnalyticsEventColor;
};
export type AppAnalyticsConsolidatedLocationsListApiResponse =
  /** status 200  */ PaginatedConsolidatedLocationList;
export type AppAnalyticsConsolidatedLocationsListApiArg = {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type AppAnalyticsConsolidatedLocationsRetrieveApiResponse =
  /** status 200  */ ConsolidatedLocation;
export type AppAnalyticsConsolidatedLocationsRetrieveApiArg =
  /** A unique integer value identifying this consolidated location. */ number;
export type AppAnalyticsContactEventsListApiResponse =
  /** status 200  */ PaginatedAnalyticsEventList;
export type AppAnalyticsContactEventsListApiArg = {
  attendees?: number[];
  /** attendees (in) */
  attendeesIn?: string;
  /** attendees (is null) */
  attendeesIsnull?: boolean;
  /** * `event_idr` - event_idr
   * `icaluid` - icaluid
   * `event_unique_id` - event_unique_id */
  distinct?: "event_idr" | "event_unique_id" | "icaluid";
  /** distinct (in) */
  distinctIn?: string;
  /** distinct (is null) */
  distinctIsnull?: string;
  endDate?: string;
  /** end_date (greater than) */
  endDateGt?: string;
  /** end_date (greater than or equal to) */
  endDateGte?: string;
  /** end_date (in) */
  endDateIn?: string;
  /** end_date (is null) */
  endDateIsnull?: boolean;
  /** end_date (less than) */
  endDateLt?: string;
  /** end_date (less than or equal to) */
  endDateLte?: string;
  id?: number;
  /** id (greater than) */
  idGt?: number;
  /** id (greater than or equal to) */
  idGte?: number;
  /** id (in) */
  idIn?: string;
  /** id (is null) */
  idIsnull?: boolean;
  /** id (less than) */
  idLt?: number;
  /** id (less than or equal to) */
  idLte?: number;
  leaders?: number[];
  /** leaders (in) */
  leadersIn?: string;
  /** leaders (is null) */
  leadersIsnull?: boolean;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Ordering
    
    * `start_date` - Start date
    * `-start_date` - Start date (descending)
    * `end_date` - End date
    * `-end_date` - End date (descending) */
  orderBy?: ("-end_date" | "-start_date" | "end_date" | "start_date")[];
  startDate?: string;
  /** start_date (greater than) */
  startDateGt?: string;
  /** start_date (greater than or equal to) */
  startDateGte?: string;
  /** start_date (in) */
  startDateIn?: string;
  /** start_date (is null) */
  startDateIsnull?: boolean;
  /** start_date (less than) */
  startDateLt?: string;
  /** start_date (less than or equal to) */
  startDateLte?: string;
  title?: string;
  /** title (contains) */
  titleContains?: string;
  /** title (endswith) */
  titleEndswith?: string;
  /** title (icontains) */
  titleIcontains?: string;
  /** title (equals, case-insensitive) */
  titleIexact?: string;
  /** title (in) */
  titleIn?: string;
  /** title (not equals, case-insensitive) */
  titleIne?: any;
  /** title (is empty or null) */
  titleIsempty?: any;
  /** title (is null) */
  titleIsnull?: boolean;
  /** title (not equals) */
  titleNe?: any;
  /** title (not contains) */
  titleNotContains?: any;
  /** title (not icontains) */
  titleNotIcontains?: any;
  /** title (startswith) */
  titleStartswith?: string;
};
export type AppAnalyticsEventCategoriesListApiResponse =
  /** status 200  */ EventCategoryListDict;
export type AppAnalyticsEventCategoriesListApiArg = void;
export type AppAnalyticsEventCategoriesCreateApiResponse =
  /** status 201  */ EventCategory;
export type AppAnalyticsEventCategoriesCreateApiArg = EventCategoryRequest;
export type AppAnalyticsEventCategoriesRetrieveApiResponse =
  /** status 200  */ EventCategory;
export type AppAnalyticsEventCategoriesRetrieveApiArg =
  /** A unique integer value identifying this event category. */ number;
export type AppAnalyticsEventCategoriesUpdateApiResponse =
  /** status 200  */ EventCategory;
export type AppAnalyticsEventCategoriesUpdateApiArg = {
  /** A unique integer value identifying this event category. */
  id: number;
  eventCategoryRequest: EventCategoryRequest;
};
export type AppAnalyticsEventCategoriesPartialUpdateApiResponse =
  /** status 200  */ EventCategory;
export type AppAnalyticsEventCategoriesPartialUpdateApiArg = {
  /** A unique integer value identifying this event category. */
  id: number;
  patchedEventCategory: PatchedEventCategory;
};
export type AppAnalyticsEventCategoriesDestroyApiResponse = unknown;
export type AppAnalyticsEventCategoriesDestroyApiArg =
  /** A unique integer value identifying this event category. */ number;
export type AppAnalyticsEventTypesListApiResponse =
  /** status 200  */ EventTypeListDict;
export type AppAnalyticsEventTypesListApiArg = void;
export type AppAnalyticsEventTypesCreateApiResponse =
  /** status 201  */ EventType;
export type AppAnalyticsEventTypesCreateApiArg = EventTypeRequest;
export type AppAnalyticsEventTypesRetrieveApiResponse =
  /** status 200  */ EventType;
export type AppAnalyticsEventTypesRetrieveApiArg =
  /** A unique integer value identifying this event type. */ number;
export type AppAnalyticsEventTypesUpdateApiResponse =
  /** status 200  */ EventType;
export type AppAnalyticsEventTypesUpdateApiArg = {
  /** A unique integer value identifying this event type. */
  id: number;
  eventTypeRequest: EventTypeRequest;
};
export type AppAnalyticsEventTypesPartialUpdateApiResponse =
  /** status 200  */ EventType;
export type AppAnalyticsEventTypesPartialUpdateApiArg = {
  /** A unique integer value identifying this event type. */
  id: number;
  patchedEventType: PatchedEventType;
};
export type AppAnalyticsEventTypesDestroyApiResponse = unknown;
export type AppAnalyticsEventTypesDestroyApiArg =
  /** A unique integer value identifying this event type. */ number;
export type AppAnalyticsEventsListApiResponse =
  /** status 200  */ PaginatedLeaderEventList;
export type AppAnalyticsEventsListApiArg = {
  attendeeLookup?: string;
  attendees?: string[];
  consolidatedLocation?: number[];
  dateScheduled?: string;
  endDate?: string;
  eventCategory?: number[];
  eventType?: number[];
  inclusion?: number[];
  isAllDay?: boolean;
  isBusy?: boolean;
  leader?: number;
  /** Number of results to return per page. */
  limit?: number;
  /** The numerical offset, in minutes, of the local timezone of the user */
  localTzOffset?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Ordering
    
    * `title` - Title
    * `-title` - Title (descending)
    * `date_scheduled` - Date scheduled
    * `-date_scheduled` - Date scheduled (descending)
    * `last_name` - Last name
    * `-last_name` - Last name (descending)
    * `status` - Status
    * `-status` - Status (descending)
    * `is_busy` - Is busy
    * `-is_busy` - Is busy (descending)
    * `leader` - Leader
    * `-leader` - Leader (descending)
    * `consolidated_location` - Consolidated location
    * `-consolidated_location` - Consolidated location (descending)
    * `start_date` - Start date
    * `-start_date` - Start date (descending)
    * `end_date` - End date
    * `-end_date` - End date (descending)
    * `event_type` - Event type
    * `-event_type` - Event type (descending)
    * `event_category` - Event category
    * `-event_category` - Event category (descending)
    * `attendees` - Attendees
    * `-attendees` - Attendees (descending)
    * `attendee_lookup` - Attendee lookup
    * `-attendee_lookup` - Attendee lookup (descending)
    * `inclusion` - Inclusion
    * `-inclusion` - Inclusion (descending)
    * `recurring_root_event_idr` - Recurring root event idr
    * `-recurring_root_event_idr` - Recurring root event idr (descending) */
  orderBy?: (
    | "-attendee_lookup"
    | "-attendees"
    | "-consolidated_location"
    | "-date_scheduled"
    | "-end_date"
    | "-event_category"
    | "-event_type"
    | "-inclusion"
    | "-is_busy"
    | "-last_name"
    | "-leader"
    | "-recurring_root_event_idr"
    | "-start_date"
    | "-status"
    | "-title"
    | "attendee_lookup"
    | "attendees"
    | "consolidated_location"
    | "date_scheduled"
    | "end_date"
    | "event_category"
    | "event_type"
    | "inclusion"
    | "is_busy"
    | "last_name"
    | "leader"
    | "recurring_root_event_idr"
    | "start_date"
    | "status"
    | "title"
  )[];
  recurrenceType?: number[];
  search?: string;
  startDate?: string;
  status?: string;
  title?: string;
  /** * `and` - And
   * `or` - Or */
  topology?: "and" | "or";
};
export type AppAnalyticsEventsUpdateApiResponse =
  /** status 200  */ LeaderEvent;
export type AppAnalyticsEventsUpdateApiArg = {
  /** A unique integer value identifying this leader event. */
  id: number;
  leaderEventRequest: LeaderEventRequest;
};
export type AppAnalyticsEventsPartialUpdateApiResponse =
  /** status 200  */ LeaderEvent;
export type AppAnalyticsEventsPartialUpdateApiArg = {
  /** A unique integer value identifying this leader event. */
  id: number;
  patchedLeaderEvent: PatchedLeaderEvent;
};
export type AppAnalyticsEventsGraphAnalyticsCreateApiResponse =
  /** status 200  */ LeaderEvent;
export type AppAnalyticsEventsGraphAnalyticsCreateApiArg = LeaderEventRequest;
export type AppAnalyticsEventsRecurringSeriesListApiResponse =
  /** status 200  */ RecurringMeetingSeries[];
export type AppAnalyticsEventsRecurringSeriesListApiArg = {
  /** When true, return active series; when false, return inactive series. */
  active?: boolean;
  /** Leader id to filter recurring meeting series by. */
  leader?: number;
  /** Search recurring meeting series by title or attendee. */
  search?: string;
};
export type AppAnalyticsEventsRecurringSeriesHideCreateApiResponse =
  /** status 200  */ HideRecurringMeetingGroup;
export type AppAnalyticsEventsRecurringSeriesHideCreateApiArg =
  HideRecurringMeetingGroupRequest;
export type AppAnalyticsEventsRecurringSeriesUpdateApiResponse =
  /** status 200  */ RecurringMeetingSeriesUpdate;
export type AppAnalyticsEventsRecurringSeriesUpdateApiArg =
  PatchedRecurringMeetingSeriesUpdate;
export type AppAnalyticsEventsResyncRetrieveApiResponse =
  /** status 200  */ LeaderEvent;
export type AppAnalyticsEventsResyncRetrieveApiArg = void;
export type AppAnalyticsExecutiveContactCategoriesListApiResponse =
  /** status 200  */ ExecTagListDict;
export type AppAnalyticsExecutiveContactCategoriesListApiArg = void;
export type AppAnalyticsExecutiveContactCategoriesCreateApiResponse =
  /** status 201  */ ExecTag;
export type AppAnalyticsExecutiveContactCategoriesCreateApiArg = ExecTagRequest;
export type AppAnalyticsExecutiveContactCategoriesRetrieveApiResponse =
  /** status 200  */ ExecTag;
export type AppAnalyticsExecutiveContactCategoriesRetrieveApiArg =
  /** A unique integer value identifying this tag. */ number;
export type AppAnalyticsExecutiveContactCategoriesUpdateApiResponse =
  /** status 200  */ ExecTag;
export type AppAnalyticsExecutiveContactCategoriesUpdateApiArg = {
  /** A unique integer value identifying this tag. */
  id: number;
  execTagRequest: ExecTagRequest;
};
export type AppAnalyticsExecutiveContactCategoriesPartialUpdateApiResponse =
  /** status 200  */ ExecTag;
export type AppAnalyticsExecutiveContactCategoriesPartialUpdateApiArg = {
  /** A unique integer value identifying this tag. */
  id: number;
  patchedExecTag: PatchedExecTag;
};
export type AppAnalyticsExecutiveContactCategoriesDestroyApiResponse = unknown;
export type AppAnalyticsExecutiveContactCategoriesDestroyApiArg =
  /** A unique integer value identifying this tag. */ number;
export type AppAnalyticsExecutiveContactTypesListApiResponse =
  /** status 200  */ PaginatedContactTypeList;
export type AppAnalyticsExecutiveContactTypesListApiArg = {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type AppAnalyticsExecutiveContactTypesRetrieveApiResponse =
  /** status 200  */ ContactType;
export type AppAnalyticsExecutiveContactTypesRetrieveApiArg =
  /** A unique integer value identifying this contact type. */ number;
export type AppAnalyticsExecutiveContactsRetrieveApiResponse = unknown;
export type AppAnalyticsExecutiveContactsRetrieveApiArg = void;
export type AppAnalyticsExecutiveContactsUpdateApiResponse = unknown;
export type AppAnalyticsExecutiveContactsUpdateApiArg =
  /** A unique integer value identifying this contact. */ number;
export type AppAnalyticsExecutiveContactsPartialUpdateApiResponse = unknown;
export type AppAnalyticsExecutiveContactsPartialUpdateApiArg =
  /** A unique integer value identifying this contact. */ number;
export type AppAnalyticsExecutiveContactsAttendeeAnalyticsCreateApiResponse =
  unknown;
export type AppAnalyticsExecutiveContactsAttendeeAnalyticsCreateApiArg = void;
export type AppAnalyticsRecurrenceTypesListApiResponse =
  /** status 200  */ PaginatedRecurrenceTypeList;
export type AppAnalyticsRecurrenceTypesListApiArg = {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type AnalysisInclusion = {
  id: number;
  name: string;
  color?: string;
};
export type PaginatedAnalysisInclusionList = {
  data: AnalysisInclusion[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type AnalyticsEventColor = {
  id?: number;
  color?: string | null;
  organization: number;
  category?: string | null;
  calendar: number;
  event_category?: number | null;
  event_type?: number | null;
};
export type AnalyticsEventColorRequest = {
  id?: number;
  color?: string | null;
  organization: number;
  category?: string | null;
  calendar: number;
  event_category?: number | null;
  event_type?: number | null;
};
export type PatchedAnalyticsEventColor = {
  id?: number;
  color?: string | null;
  organization?: number;
  category?: string | null;
  calendar?: number;
  event_category?: number | null;
  event_type?: number | null;
};
export type ConsolidatedLocation = {
  id: number;
  name: string;
  color?: string;
};
export type PaginatedConsolidatedLocationList = {
  data: ConsolidatedLocation[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type ExternalEventLocation = {
  id: number;
  name: string;
  email?: string | null;
  /** * `virtual_conference` - Web Conference
   * `phone` - Phone Call
   * `in_person` - In Person
   * `other` - Other */
  location_type?: "virtual_conference" | "phone" | "in_person" | "other";
};
export type AnalyticsEvent = {
  id: number;
  event_idr: string;
  recurring_root_event_idr: string | null;
  title: string;
  attendees: number[];
  start_date: string;
  end_date: string;
  date_scheduled: string | null;
  cabinet_create_date: string;
  cabinet_update_date: string;
  /** * `SCHEDULED` - SCHEDULED
   * `CANCELED` - CANCELED
   * `IN_PROGRESS` - IN_PROGRESS */
  status: "SCHEDULED" | "CANCELED" | "IN_PROGRESS";
  is_busy: boolean;
  external_event_locations?: ExternalEventLocation[];
  meeting: number | null;
  conference_provider: number | null;
};
export type PaginatedAnalyticsEventList = {
  data: AnalyticsEvent[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type EventCategory = {
  id: number;
  name: string;
  color: string;
  organization: number;
};
export type EventCategoryListDict = {
  [key: string]: EventCategory;
};
export type EventCategoryRequest = {
  name: string;
  color: string;
  organization: number;
};
export type PatchedEventCategory = {
  name?: string;
  color?: string;
  organization?: number;
};
export type EventType = {
  id: number;
  name: string;
  color: string;
  organization: number;
};
export type EventTypeListDict = {
  [key: string]: EventType;
};
export type EventTypeRequest = {
  name: string;
  color: string;
  organization: number;
};
export type PatchedEventType = {
  name?: string;
  color?: string;
  organization?: number;
};
export type LeaderEvent = {
  id: number;
  event_category?: number | null;
  event_type?: number | null;
  leader: number;
  recurring_root_event_idr: string | null;
  title: string;
  attendees: number[];
  start_date: string;
  end_date: string;
  date_scheduled: string;
  status: string;
  consolidated_location?: number | null;
  recurrence_type?: number | null;
  inclusion?: number;
  is_all_day: boolean;
};
export type ContactDateValueMeta = {
  timezone: string;
};
export type ContactFieldMeta = {
  date_value?: ContactDateValueMeta | null;
};
export type ContactField = {
  text_value?: string | null;
  choices?: number[] | null;
  meta?: ContactFieldMeta | null;
};
export type ContactEmail = {
  id: number;
  /** Email address */
  email: string;
  /** Whether this is the primary email for the contact */
  is_primary?: boolean;
  /** Organization this email belongs to */
  organization: number;
  created_at?: string;
  updated_at?: string;
};
export type Contact = {
  id: number;
  created_at?: string;
  updated_at?: string;
  timezone?: string | null;
  fields?: {
    [key: string]: ContactField;
  };
  tags?: number[];
  emails: ContactEmail[];
  primary_email?: string;
  all_emails?: string[];
  name: string | null;
  title?: string | null;
  location?: string | null;
  assistant_name?: string | null;
  assistant_email?: string | null;
  phone_number?: string | null;
  linkedin_url?: string | null;
  is_resource?: boolean;
  last_observed_email?: string | null;
  last_observed_name?: string | null;
  avatar?: string | null;
  hidden_date?: string | null;
  contact_category?: number | null;
  organization?: number | null;
  contact_type?: number | null;
  company?: number | null;
  leaders: (number | null)[];
  private_leaders?: (number | null)[];
};
export type PaginatedLeaderEventList = {
  data: {
    events: {
      [key: string]: LeaderEvent;
    };
    contacts: {
      [key: string]: Contact;
    };
  };
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
    id_order?: number[];
    min_start_date?: string;
    max_end_date?: string;
    most_recent_log?: string;
    most_recent_started_log_date?: string;
    most_recent_completed_log_date?: string;
    most_recent_queued_log_date?: string;
  };
};
export type LeaderEventRequest = {
  event_category?: number | null;
  event_type?: number | null;
  leader: number;
  consolidated_location?: number | null;
  recurrence_type?: number | null;
  inclusion?: number;
  update_all?: boolean;
};
export type PatchedLeaderEvent = {
  event_category?: number | null;
  event_type?: number | null;
  leader?: number;
  consolidated_location?: number | null;
  recurrence_type?: number | null;
  inclusion?: number;
  update_all?: boolean;
};
export type RecurringMeetingSeries = {
  id: string;
  recurring_root_event_idr: string;
  leader: number;
  meeting_name: string;
  normalized_meeting_name: string;
  frequency: string | null;
  day_of_week: string;
  time: string;
  duration_minutes: number;
  attendees: string[];
  meeting_owner: string;
  meeting_organizer: string;
  notes: string | null;
  calendar_id: string;
  series_start_date: string;
  series_end_date: string | null;
  rrule: string | null;
  dtstart: string;
  grouping_parent_id: string | null;
  grouping_child_ids: string[];
};
export type HideRecurringMeetingGroup = {
  leader: number;
  normalized_meeting_name: string;
  sample_recurring_root_event_idr: string;
};
export type HideRecurringMeetingGroupRequest = {
  leader: number;
  normalized_meeting_name: string;
  sample_recurring_root_event_idr: string;
};
export type RecurringMeetingSeriesUpdate = {
  leader: number;
  recurring_root_event_idr: string;
  notes?: string | null;
};
export type PatchedRecurringMeetingSeriesUpdate = {
  leader?: number;
  recurring_root_event_idr?: string;
  notes?: string | null;
};
export type ExecTag = {
  id: number;
  name: string;
  color: string;
  organization: number;
};
export type ExecTagListDict = {
  [key: string]: ExecTag;
};
export type ExecTagRequest = {
  name: string;
  color: string;
};
export type PatchedExecTag = {
  name?: string;
  color?: string;
};
export type ContactType = {
  id: number;
  name: string;
  color?: string;
};
export type PaginatedContactTypeList = {
  data: ContactType[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type RecurrenceType = {
  id: number;
  name: string;
  color?: string;
};
export type PaginatedRecurrenceTypeList = {
  data: RecurrenceType[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export const {
  useAppAnalyticsAnalysisInclusionsListQuery,
  useAppAnalyticsAnalysisInclusionsRetrieveQuery,
  useAppAnalyticsAnalyticsColorsListQuery,
  useAppAnalyticsAnalyticsColorsRetrieveQuery,
  useAppAnalyticsAnalyticsColorsUpdateMutation,
  useAppAnalyticsAnalyticsColorsPartialUpdateMutation,
  useAppAnalyticsConsolidatedLocationsListQuery,
  useAppAnalyticsConsolidatedLocationsRetrieveQuery,
  useAppAnalyticsContactEventsListQuery,
  useAppAnalyticsEventCategoriesListQuery,
  useAppAnalyticsEventCategoriesCreateMutation,
  useAppAnalyticsEventCategoriesRetrieveQuery,
  useAppAnalyticsEventCategoriesUpdateMutation,
  useAppAnalyticsEventCategoriesPartialUpdateMutation,
  useAppAnalyticsEventCategoriesDestroyMutation,
  useAppAnalyticsEventTypesListQuery,
  useAppAnalyticsEventTypesCreateMutation,
  useAppAnalyticsEventTypesRetrieveQuery,
  useAppAnalyticsEventTypesUpdateMutation,
  useAppAnalyticsEventTypesPartialUpdateMutation,
  useAppAnalyticsEventTypesDestroyMutation,
  useAppAnalyticsEventsListQuery,
  useAppAnalyticsEventsUpdateMutation,
  useAppAnalyticsEventsPartialUpdateMutation,
  useAppAnalyticsEventsGraphAnalyticsCreateMutation,
  useAppAnalyticsEventsRecurringSeriesListQuery,
  useAppAnalyticsEventsRecurringSeriesHideCreateMutation,
  useAppAnalyticsEventsRecurringSeriesUpdateMutation,
  useAppAnalyticsEventsResyncRetrieveQuery,
  useAppAnalyticsExecutiveContactCategoriesListQuery,
  useAppAnalyticsExecutiveContactCategoriesCreateMutation,
  useAppAnalyticsExecutiveContactCategoriesRetrieveQuery,
  useAppAnalyticsExecutiveContactCategoriesUpdateMutation,
  useAppAnalyticsExecutiveContactCategoriesPartialUpdateMutation,
  useAppAnalyticsExecutiveContactCategoriesDestroyMutation,
  useAppAnalyticsExecutiveContactTypesListQuery,
  useAppAnalyticsExecutiveContactTypesRetrieveQuery,
  useAppAnalyticsExecutiveContactsRetrieveQuery,
  useAppAnalyticsExecutiveContactsUpdateMutation,
  useAppAnalyticsExecutiveContactsPartialUpdateMutation,
  useAppAnalyticsExecutiveContactsAttendeeAnalyticsCreateMutation,
  useAppAnalyticsRecurrenceTypesListQuery,
} = injectedRtkApi;
